import { ActionType, createAction } from 'typesafe-actions'
import { ContactState } from '../../types'
import { Request } from './types'

export const setCurrentContactAction = createAction('@contact/SET_CURRENT_CONTACT')<Request>()

const success = (state: ContactState, action: ActionType<typeof setCurrentContactAction>): ContactState => ({
  ...state,
  currentContact: action.payload.contact
})

export const setCurrentContactHandle = { asyncAction: setCurrentContactAction, success }
